module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Календарь"}}')
  delete Component.options._Ctor
}
